<template>
    <CqModal
        :showModal="show"
        heading="Stel het aantal gewenste dagen zichtbaar in"
        @closeModal="closeModal"
    >
        <CqTextInput :label="'Kies een waarde tussen ' + minimumDays + ' en ' + maximumDays + '.'" type="number" v-model="value" :min="minimumDays" :max="maximumDays" />
        <CqButtonBar>
            <CqButton primary @click="save" :disabled="hasError" label="Instellen" />
        </CqButtonBar>
    </CqModal>
</template>

<script lang="ts">
    import {CqButton, CqButtonBar, CqModal, CqTextInput} from '@cquential/ui';
    import {Component, Model, Prop, Vue, Watch} from 'vue-facing-decorator';

    @Component({
        components: {
            CqButton,
            CqButtonBar,
            CqModal,
            CqTextInput,
        },
        emits: ['update:modelValue'],
    })
    export default class CustomDaysVisibleModal extends Vue {
        @Model({required: true}) public daysVisible!: number;
        @Prop({type: Boolean}) public show!: boolean;

        public static readonly MINIMUM_VISIBLE_DAYS: number = 1;
        public static readonly MAXIMUM_VISIBLE_DAYS: number = 56;

        public value: number = 1;

        public get minimumDays(): number {
            return CustomDaysVisibleModal.MINIMUM_VISIBLE_DAYS;
        }

        public get maximumDays(): number {
            return CustomDaysVisibleModal.MAXIMUM_VISIBLE_DAYS;
        }

        public mounted(): void {
            this.value = this.daysVisible;
        }

        @Watch('daysVisible')
        public onModelValueChanged(): void {
            this.value = this.daysVisible;
        }

        public get hasError(): boolean {
            return this.errorLabel !== undefined;
        }

        public get errorLabel(): string | undefined {
            if (this.value === undefined) {
                return 'Vul een waarde in';
            } else if (this.value < this.minimumDays) {
                return 'Aantal dagen is onder het minimum';
            } else if (this.value > this.maximumDays) {
                return 'Aantal dagen is boven het maximum';
            }

            return undefined;
        }

        public save(): void {
            this.daysVisible = this.value;
        }

        public closeModal(): void {
            this.daysVisible = -1;
        }
    }
</script>
